import api from '../../../../api';

export const UploadSelector = {
  UPLOAD: api.internals.ns.selector('upload')
};
